export default {
  tabs: {
    online_shop: 'Negozio online',
    reservations: 'Prenotazioni',
    storefront: 'Vetrina',
  },
};
